import {
  FETCH_METER_WITH_BESS,
  FETCH_METER_WITHOUT_BESS
} from "../../actions/types";

const INITIAL_STATE = {
  withBess: {
    results: []
  },
  withoutBess: {
    results: []
  }
};

const meterReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FETCH_METER_WITH_BESS:
      return {
        ...state,
        withBess: payload.data
      };
    case FETCH_METER_WITHOUT_BESS:
      return {
        ...state,
        withoutBess: payload.data
      };
    default:
      return state;
  }
};

export default meterReducer;



// WEBPACK FOOTER //
// ./src/reducers/helpers/meter_reducer.js